import React, { Component } from 'react'
import { connect } from 'react-redux'
import EditUserEmailForm from '../../../components/forms/account/EditUserEmailForm'
import {updateUserEmail} from '../../../actions/user'
import {showNotification} from '../../../actions/notifications'


class UpdateEmailContainer extends Component {
  
	constructor(props){
		super(props)
		this.updateUserEmail=this.updateUserEmail.bind(this)

		this.state = {
			submitLoading:false,
			errorMessage:null,
			attemptNumber:1
		
		}
		
	}
 

	updateUserEmail(formData) {
		this.setState({submitLoading:true,errorMessage:null})
		const requestData = {
			'email': formData.email,
			'password': formData.currentPassword,
			'recaptchaResponse':formData.recaptchaResponse 
		}
		this.props.updateUserEmail(requestData, this.props.user.id).then((response) => {
	 		const notificationMessage=`to ${formData.email}`
	 		this.props.showNotification(notificationMessage,'Updated Email','default')
			this.props.hideModal()
		 })

			.catch(error => {
				let errorMessage='Please try again. If the problem persists, contact support.'
				if(error.response.status===412){
					errorMessage='The password you entered was incorrect'
				}else if(error.response.status===409){
					errorMessage='An account with that email already exists'
				}else if(error.response.status===422){
					errorMessage='user has google ID - email can not be updated'
				}
				this.setState({submitLoading:false,errorMessage:errorMessage,attemptNumber:this.state.attemptNumber+1})


			})
	}
 

	render() {
		const {user}=this.props
		const {errorMessage,submitLoading}=this.state

		return (
			<React.Fragment>

				<EditUserEmailForm
					email={user.email}
					onSubmit={this.updateUserEmail}
					submitLoading={submitLoading}
					attemptNumber={this.state.attemptNumber}
				/>

				{errorMessage &&
					<div className='accountForm-error'>									
						{errorMessage}				
					</div>
				}

			</React.Fragment>
		)
	}
}
 

export default connect(
	(state) => ({
		user:state.user,

	}),
	{ updateUserEmail,showNotification}
)(UpdateEmailContainer)


